import { Col, Modal, Row } from '@greenglobal/greencore.fe.common'
import { Form, FormItem, useForm } from '@greenglobal/greencore.fe.form'

import { VALIDATE } from '@/constants/rules'
import styles from './styles.module.scss'

interface ModalProps {
  toggleModal: boolean
  onCloseModal?: () => void
}

export const ModalChangePassword = ({ onCloseModal, toggleModal }: ModalProps) => {
  const [formModal] = useForm()

  const closeModalHandler = () => {
    onCloseModal?.()
  }

  const onFinish = (values: { [key: string]: any }) => {
    onCloseModal?.()
  }

  return (
    <Modal
      wrapClassName={styles.modal__wrapper}
      okText='Lưu'
      cancelText='Đóng'
      width={800}
      onCancel={closeModalHandler}
      onOk={() => formModal.submit()}
      open={toggleModal}
      title='ĐỔI MẬT KHẨU'
    >
      <div>
        <Form layout='vertical' form={formModal} onFinish={onFinish}>
          <Row gutter={24} className={styles['input']}>
            <Col span={24}>
              <FormItem type='inputPassword' name='code' label='Nhập mật khẩu cũ' rules={[VALIDATE.required]} />
            </Col>
            <Col span={24}>
              <FormItem type='inputPassword' name='code' label='Nhập mật khẩu mới' rules={[VALIDATE.required]} />
            </Col>
            <Col span={24}>
              <FormItem type='inputPassword' name='code' label='Nhập lại mật khẩu mới' rules={[VALIDATE.required]} />
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}
